import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'
import useForm from '@/hooks/form/use-form.hook'

import { FormStatusType } from '@/enums/form-status.enum'
import { authSelector } from '@/state/auth/slices/index.slices'
import { StateSchema } from '@/hooks/form/models'

import { bonusAmountSchema } from '../components/schema'
import { bonusAmountValidator } from '../components/validator'

const useBonusAmount = () => {
  const { currentBonus, bonusFormMode } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  const { brand } = useSelector(authSelector)

  const { state, handleOnChange, disable, setFormValues, setDisable } = useForm(
    bonusAmountSchema(brand.currencies),
    bonusAmountValidator(brand.currencies),
    () => {},
  )

  const setCurrentBonusAmount = () => {
    let schema: StateSchema = {}

    currentBonus.bonusAmount && currentBonus.bonusAmount.length > 0
      ? currentBonus.bonusAmount?.forEach((bonus) => {
          schema = {
            ...schema,
            [`percentage_${bonus.currency}`]: {
              value: bonus.percentage?.toString() || '',
              error: '',
            },
            [`cap_${bonus.currency}`]: {
              value: bonus.cap?.toString() || '',
              error: '',
            },
            [`fixed_${bonus.currency}`]: {
              value: bonus.fixed?.toString() || '',
              error: '',
            },
          }
        })
      : brand.currencies.forEach((currency) => {
          schema = {
            ...schema,
            [`percentage_${currency}`]: {
              value: '',
              error: '',
            },
            [`cap_${currency}`]: {
              value: '',
              error: '',
            },
            [`fixed_${currency}`]: {
              value: '',
              error: '',
            },
          }
        })

    setFormValues({
      amountType: {
        value:
          currentBonus.bonusAmount &&
          currentBonus.bonusAmount.length > 0 &&
          currentBonus.bonusAmount[0].fixed !== 0 &&
          currentBonus.bonusAmount[0].fixed !== undefined
            ? 'FIXED'
            : 'PERCENTAGE',
        error: '',
      },
      ...schema,
    })

    bonusFormMode === FormStatusType.CREATE
      ? setDisable(true)
      : setDisable(false)
  }

  return {
    bonusAmount: {
      state,
      handleOnChange,
      disable,
      setFormValues,
      setDisable,
    },
    setCurrentBonusAmount,
  }
}

export default useBonusAmount
